<template>
  <section class="content-header">
    <h1>Informe de agendas</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="operarios">Operarios</label>
              <MultiSelect v-model="operariosseleccionados" inputId="operarios"
                placeholder="Todos los operarios"
                :options="operarios" optionLabel="nombre" optionValue="idoperario" filter
                display="chip" :maxSelectedLabels="3"
                selectedItemsLabel="{0} operarios seleccionados"
                scrollHeight="400px" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label>Estado</label>
              <div class="checkbox-linea">
                <Checkbox v-model="pendiente" :binary="true" inputId="pendiente" />
                <label for="pendiente">Pendientes</label>
              </div>
              <div class="checkbox-linea">
                <Checkbox v-model="confirmada" :binary="true" inputId="confirmada" />
                <label for="confirmada">Confirmadas</label>
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label class="label-vacia">&nbsp;</label>
              <button class="btn btn-primary btn-block" @click="cargarInforme" :disabled="generando">
                <i class="fa" :class="generando ? 'fa-spinner fa-spin' : 'fa-file-excel-o'"></i>
                {{ generando ? 'Generando...' : 'Generar Excel' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" target="iframeInforme" style="display:none"></form>
    <iframe name="iframeInforme" style="display:none"></iframe>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import MultiSelect from 'primevue/multiselect';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';

export default {
  components: { MultiSelect, Calendar, Checkbox },

  data() {
    const hoy = new Date();
    return {
      operarios: [],
      operariosseleccionados: [],
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      pendiente: true,
      confirmada: true,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme() {
      this.generando = true;
      try {
        const api = new PwgsApi();

        // El operario va vacío: los añadimos nosotros como array
        const html = await api.post('informes/informe_agendas', {
          tipo_respuesta: 'xls',
          id_operario: '',
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin),
          pendiente: this.pendiente ? 1 : '',
          confirmada: this.confirmada ? 1 : ''
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        // Todos los campos menos el operario vacío
        formOrigen.querySelectorAll('input').forEach(input => {
          if (input.name !== 'operarios') anyadir(input.name, input.value);
        });

        // Un operarios[] por cada seleccionado (ninguno = todos)
        this.operariosseleccionados.forEach(id => anyadir('operarios[]', id));

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarOperarios() {
      const api = new PwgsApi();
      const response = await api.get('operarios/simple');
      this.operarios = response.datos;
    }
  },

  mounted() {
    this.cargarOperarios();
  }
};
</script>
<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

/* PrimeVue no ocupa el ancho del contenedor por defecto */
.w-100 :deep(.p-multiselect),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.checkbox-linea {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.checkbox-linea label {
  margin: 0;
  font-weight: normal;
  cursor: pointer;
}

/* Alinea el botón con la base de los inputs */
.label-vacia {
  display: block;
}
</style>